import React, { useEffect } from 'react';
import { Form } from 'components/ds';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { useGetCep } from 'modules/account/services/AddressService';
import { USER_DATA_KEY } from '../../../constantes/LocalStorageEnum';
import { useFormInitialValues } from '../../../hooks/useFormInitialValues';

const Address: React.FC = () => {
  const [form] = Form.useForm();
  const [isLoadingCep, setIsLoadingCep] = React.useState(false);
  const cepValue = Form.useWatch('address_postalcode', form);
  const {mutate: getCep} = useGetCep();
  
  const userData = ApiLocalStorage.get(USER_DATA_KEY);
  const initialValues = useFormInitialValues('address', userData);
  
  const streetMaxLength = 50;
  const districtMaxLength = 20;
  const cityMaxLength = 20;
  
  useEffect(() => {
    if (cepValue) {
      const updatedCep = cepValue?.replace(/[^0-9]/g, '');
      
      if (updatedCep?.length === 8) {
        const allValues = form.getFieldsValue();
        ApiLocalStorage.set('address', {
          ...allValues,
          address_postalcode: updatedCep
        });
        
        if (updatedCep) {
          setIsLoadingCep(true);
          getCep(cepValue, {
            onSuccess: (data) => {
              const currentValues = form.getFieldsValue();
              const formattedCep = data.cep.replace(/(\d{5})(\d{3})/, '$1-$2');
              const formattedLogradouro = data.logradouro ? data.logradouro.substring(0, streetMaxLength) : '';
              const formattedDistrict = data.bairro ? data.bairro.substring(0, districtMaxLength) : '';
              const formattedCity = data.localidade ? data.localidade.substring(0, cityMaxLength) : '';
              
              form.setFieldsValue({
                ...currentValues,
                address_postalcode: formattedCep,
                address_street: formattedLogradouro,
                address_district: formattedDistrict,
                address_city: formattedCity,
                address_state: data.uf
              });
              setIsLoadingCep(false);
            },
            onError: () => {
              setIsLoadingCep(false);
            }
          });
        }
      }
    }
  }, [cepValue, form, getCep]);
  
  // Inicializa o formulário com dados processados
  useEffect(() => {
    if (initialValues.address_postalcode) {
      // Formatar CEP se existe e é uma string
      const postalCode = initialValues.address_postalcode;
      const formattedValues = {
        ...initialValues,
        address_postalcode: typeof postalCode === 'string' && postalCode
          ? postalCode.replace(/(\d{5})(\d{3})/, '$1-$2')
          : postalCode
      };
      
      form.setFieldsValue(formattedValues);
    }
  }, [form, initialValues.address_postalcode]);
  
  return (
    <DynamicForm
      pageName="address"
      form={form}
      loadingFields={{
        [cepValue]: isLoadingCep
      }}
    />
  );
};

export default Address;
